import { Box, ListItemText, MenuItem, MenuItemProps } from '@mui/material';
import { ICON_PX } from '~/theme/iconSizes';
import { FormattedMessage } from 'react-intl';
import { RoiReadModel } from '~/domain/readmodels/StructureSetReadModel';
import { useStructureDisplayColor } from '~/hooks/structure-set/useStructureColorEdit';
import RoiColor from './RoiColor';

/**
 * "Change Color…" in a structure's menu, with the structure's colour as
 * its icon and, when the edit is withheld, the message of
 * `withheldReasonId` beneath it. The MenuItem props pass through — a Menu
 * steers focus through its direct children's props, so a withheld item is
 * passed `disabled` as well as its reason.
 */
export default function StructureColorMenuItem({
    roi,
    withheldReasonId,
    ...menuItemProps
}: MenuItemProps & { roi: RoiReadModel; withheldReasonId?: string }) {
    return (
        <MenuItem {...menuItemProps} data-testid="change-color-menu-item">
            <Box
                display="flex"
                justifyContent="center"
                width={ICON_PX}
                flexShrink={0}
            >
                <RoiColor color={useStructureDisplayColor(roi)} size={12} />
            </Box>
            <ListItemText
                primary={<FormattedMessage id="colorPicker.changeColor" />}
                secondary={
                    withheldReasonId && (
                        <FormattedMessage id={withheldReasonId} />
                    )
                }
                secondaryTypographyProps={{
                    sx: { maxWidth: 300, whiteSpace: 'normal' },
                }}
            />
        </MenuItem>
    );
}
